
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `أضفه إلى شاشتك الرئيسية للحصول على تجربة شاملة ووصول سهل.`,
's224cbcec014ef6b5': `اضغط على مشاركة في الشريط العلوي`,
's37a9e8aec5713460': `المزيد`,
's386eca8362ff6155': `اضغط على المزيد إذا لم يكن هناك رمز مشاركة`,
's4e1e10a6ca408245': `انقر على "إضافة إلى الشاشة الرئيسية"`,
's6196153c4b0c1ea0': `تثبيت`,
's633502f7cff4f847': `افتح قائمة المتصفح`,
's681e399d63311fba': `عرض الصور`,
's7f0591f08e318eda': `اضغط على المزيد في قائمة المشاركة`,
's8114bd55cae5a22b': `اضغط على إضافة إلى القوائم`,
's922329d6f6213590': `إضافة إلى القوائم`,
's9af56bf005b49c74': `اسحب لأسفل إلى "إضافة إلى الشاشة الرئيسية"`,
'sa5ef80b4bb9b39f8': `أقل`,
'sba52286c21552a4e': `ثبّته على جهازك للحصول على تجربة شاملة ووصول سهل.`,
'sc16e00a7a8b2fde2': `رجوع`,
'scdaf4bbff76674c8': `إضافة إلى الشاشة الرئيسية`,
'se0e473adfda8066c': `افتح في المتصفح الرئيسي`,
'se740f75b95a51807': `أضفه إلى شريط القوائم للحصول على تجربة شاملة ووصول سهل.`,
'sfea652f6580ff086': `يتمتع هذا الموقع بوظائف التطبيق.`,
    };
  